import "../../../styles/requests.css";
import { convertTo12HourPlusDateFormat } from "../../../util/helperFunctions";

function CCARItem({ data }) {
  // The detail endpoint looks requests up by the form request id, not
  // request_link_id (the CCAR record's own id).
  const detailUrl =
    `/requests?p=view-request-detail` +
    `&t=${encodeURIComponent(data?.request_type || "")}` +
    `&r=${encodeURIComponent(data?.id || "")}` +
    `&r_url=${encodeURIComponent(window.location.href)}`;

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "approved";

      case "denied":
      case "rejected":
        return "denied";

      case "cancelled":
        return "cancelled";

      case "pending":
      default:
        return "pending";
    }
  };

  const status = data?.final_status || "Pending";

  return (
    <a className="request-item--list-container" href={detailUrl}>
      <div className="request-item--row">
        <div className="request--item-logo">
          <i
            className="fa fa-file-text-o fa-4x"
            aria-hidden="true"
          ></i>
        </div>

        <div>
          <div className="request-ref-no">
            <h1>{data?.reference_id}</h1>
          </div>

          <div className="request--detail">
            <div className="request--detail-item">
              <span>Employee:&nbsp;</span>
              <span>{data?.user_detail?.display_name}</span>
            </div>

            <div className="request--detail-item">
              <span>Request Type:&nbsp;</span>
              <span>{data?.request_type}</span>
            </div>

            <div className="request--detail-item">
              <span>Warehouse:&nbsp;</span>
              <span>{data?.warehouse || "N/A"}</span>
            </div>

            <div className="request--detail-item">
              <span>Date & Time Requested:&nbsp;</span>
              <span>
                {convertTo12HourPlusDateFormat(data?.createdAt)}
              </span>
            </div>

            {data?.approved_by?.display_name && (
              <div className="request--detail-item">
                <span>Approved By:&nbsp;</span>
                <span>{data.approved_by.display_name}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="request--detail-status">
        <div
          className={`status ${getStatusClass(
            status
          )} request--item-approval-status`}
        >
          <span>{status}</span>
        </div>
      </div>
    </a>
  );
}

export default CCARItem;